import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import CloseIcon from "@mui/icons-material/Close";
import { IconButton } from "@mui/material";

import useStyles from "./useStyles";

const SpinningCloseButton = (props) => {
  const classes = useStyles();
  const { onClick, className } = props;

  return (
    <IconButton
      color="primary"
      aria-label="close"
      classes={{ root: clsx(classes.buttonClose, className) }}
      onClick={onClick}
      size="large"
    >
      <CloseIcon fontSize="inherit" />
    </IconButton>
  );
};

SpinningCloseButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string,
};

SpinningCloseButton.defaultProps = {
  className: "",
};

export default SpinningCloseButton;
